import React, { useEffect, useState, useRef } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import Header from "../../../../components/Layout/Header/Header";
import Footer from "../../../../components/Layout/Footer/Footer";
import ScrollToTop from "../../../../components/Common/ScrollTop";
import OffWrap from "../../../../components/Layout/Header/OffWrap";
import SiteBreadcrumb from "../../../../components/Common/Breadcumb";
import SearchModal from "../../../../components/Layout/Header/SearchModal";
import footerLogo from "../../../../assets/img/logo/jntua-logo.png";
import { fetchData, imageBaseURL } from "../../../../utils/fetchData";
import Accreditation from "../../../../components/Common/Accreditation";
import { useFontSize } from "../../../../FontSizeContext";
import {
    getAPIPath,
    getMenu
} from "../../../../utils/getDomainData";
import Slider from "react-slick";
import { BlocksRenderer } from "../../../../components/BlockRenderer";

const SMSHomeMain = () => {
    const [data, setData] = useState([]);
    const [profileData, SetProfileData] = useState(null);
    let location = useLocation();
    const currentDomain = location.pathname.split("/")[1];

    const { fontSize } = useFontSize();

    const [autoplaySpeed, setAutoplaySpeed] = useState(20000);
    const sliderRef = useRef(null);

    const sliderSettings = {
        dots: false,
        centerMode: false,
        autoplay: true,
        autoplaySpeed: autoplaySpeed,
        infinite: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        beforeChange: (current, next) => {
            if (next === 0) {
                setAutoplaySpeed(20000);
            }
            if (next === 1) {
                setAutoplaySpeed(25000);
            }
            if (next === 2) {
                setAutoplaySpeed(36000);
            }
            if (next === 3) {
                setAutoplaySpeed(42000);
            } else {
                setAutoplaySpeed(30000);
            }
        },
    };

    useEffect(() => {
        fetchData(getAPIPath(currentDomain)?.home, setData);
        fetchData(getAPIPath(currentDomain)?.profile, SetProfileData);
    }, [currentDomain]);

    const smsData = data?.data?.attributes;

    return (
        <React.Fragment>
            <Helmet>
                <title>{smsData?.title || "School of Management Studies"} | JNTU Anantapur</title>
                <meta
                    name="description"
                    content={smsData?.title || "School of Management Studies of Jawaharlal Nehru Technological University Anantapur"}
                />
                <meta
                    name="keywords"
                    content="SMS, School of Management Studies, JNTUA, MBA, Management Education, Anantapur"
                ></meta>
            </Helmet>
            <OffWrap />
            <Header
                parentMenu="home"
                TopBar="enable"
                TopBarClass="topbar-area dark-primary-bg hidden-lg"
            />
            <style>
                {`
                    body,
                    .rs-latest-events.style1 .event-wrap .events-short .date-part .date,
                    .widget ul li a {
                        font-size: ${fontSize}px;
                    }
                    .rs-inner-blog .blog-item .blog-content .blog-title,
                    .widget h1,.content-wrapper h2, .heading, .college-title{
                        font-size: calc(${fontSize}px + 10px);
                    }
                    .breadcrumb-bg .breadcrumbs-text ul li{
                      font-size: calc(${fontSize}px + 2px);
                    }
                    
                    .full-width-header .rs-header .topbar-area .topbar-right li.login-register a,
                    .readon.orange-btn, .rs-latest-events.bg-wrap .notification-filter button,
                    .rs-latest-events.style1 .event-wrap:not(.ls-area) .events-short .slNo, 
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > a,
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > ul li > a,
                    table th, table td {                       
                        font-size: calc(${fontSize}px - 2px);
                    }

                    .rs-footer .footer-top-social .social_msg{
                        font-size: calc(${fontSize}px + 18px);
                    }
                    .rs-footer .footer-center h3{
                        font-size: calc(${fontSize}px + 12px);
                    }
                    .rs-footer.home9-style .footer-top .widget-title,
                    .rs-team.style1 .about-btn--primary,
                    .rs-team.style1 .about-btn--secondary,
                    .course-overview .inner-box h5{
                        font-size: calc(${fontSize}px + 4px);
                    }
                    .rs-footer .footer-center h4,
                    .rightBar h4{
                        font-size: calc(${fontSize}px + 6px);
                    }
                    .sms-section {
                        padding: 40px 0;
                    }
                    .sms-intro {
                        background: #f8f9fa;
                        padding: 40px 0;
                    }
                    .vision-mission-values {
                        padding: 50px 0;
                    }
                    .vmv-card {
                        background: #fff;
                        border-radius: 10px;
                        box-shadow: 0 5px 15px rgba(0,0,0,0.1);
                        padding: 30px;
                        margin-bottom: 30px;
                        height: 100%;
                    }
                    .vmv-card h3 {
                        color: #ff6600;
                        margin-bottom: 20px;
                        border-bottom: 3px solid #ff6600;
                        padding-bottom: 10px;
                    }
                    .vmv-list {
                        list-style: none;
                        padding: 0;
                    }
                    .vmv-list li {
                        padding: 8px 0;
                        border-bottom: 1px solid #eee;
                        position: relative;
                        padding-left: 20px;
                    }
                    .vmv-list li:before {
                        content: "✓";
                        color: #ff6600;
                        font-weight: bold;
                        position: absolute;
                        left: 0;
                    }
                    .announcements-section {
                        background: #f8f9fa;
                        padding: 50px 0;
                    }
                    .announcements-grid {
                        display: grid;
                        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
                        gap: 30px;
                        margin-top: 30px;
                    }
                    .announcement-card {
                        background: #fff;
                        border-radius: 10px;
                        padding: 25px;
                        box-shadow: 0 3px 10px rgba(0,0,0,0.1);
                    }
                    .announcement-card h4 {
                        color: #333;
                        margin-bottom: 15px;
                        font-size: calc(${fontSize}px + 6px);
                    }
                    .announcement-list {
                        list-style: none;
                        padding: 0;
                    }
                    .announcement-list li {
                        padding: 8px 0;
                        border-bottom: 1px solid #eee;
                        color: #666;
                    }
                    .image-scroller {
                        padding: 50px 0;
                    }
                    .scroller-container {
                        display: flex;
                        overflow-x: auto;
                        gap: 20px;
                        padding: 20px 0;
                    }
                    .scroller-image {
                        min-width: 300px;
                        height: 200px;
                        border-radius: 10px;
                        overflow: hidden;
                        box-shadow: 0 5px 15px rgba(0,0,0,0.1);
                    }
                    .scroller-image img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                    .associate-entities {
                        background: #fff;
                        padding: 40px 0;
                        text-align: center;
                    }
                    .entities-grid {
                        display: grid;
                        grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
                        gap: 20px;
                        margin-top: 30px;
                    }
                    .entity-item {
                        padding: 15px;
                        border: 1px solid #eee;
                        border-radius: 8px;
                        transition: all 0.3s ease;
                    }
                    .entity-item:hover {
                        box-shadow: 0 5px 15px rgba(0,0,0,0.1);
                        transform: translateY(-2px);
                    }
                  
                    
                `}
            </style>
            <div className="pageTopOffset rs-slider main-home">

                {/* Image Scroller */}
                {smsData?.imageScroller?.data && smsData.imageScroller.data.length > 0 && (
                    <Slider {...sliderSettings} ref={sliderRef}>
                        {smsData.imageScroller.data.map((image, index) => (
                            <div key={index}>
                                <div className="slider-content">
                                    <div className="bgMedia">
                                        <img src={`${imageBaseURL}${image.attributes.url}`}
                                            alt={image.attributes.alternativeText || smsData.title}
                                        />
                                    </div>
                                    <div className="fixedBannerTitle">
                                        <div className="container">
                                            <div className="content-part">
                                                <h2 className="sl-title">
                                                    School of Management Studies
                                                </h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Slider>
                )}




                {getMenu(currentDomain)}

                {/* Introduction Section */}
                <div className="sms-intro content-wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <h2 title={smsData?.title} style={{ marginBottom: "20px" }}>{smsData?.title}</h2>
                                {smsData?.introParagraph && (
                                    <div className="intro-content">
                                        <BlocksRenderer content={smsData.introParagraph} />
                                    </div>
                                )}

                            </div>
                        </div>
                    </div>
                </div>

                {/* Vision, Mission & Values Section */}
                <div className="vision-mission-values">
                    <div className="container">

                        <div className="row">
                            {/* Debug: Show section title always */}
                            <div className="col-12 mb-4">
                                <h2 className="text-center">Vision, Mission & Values</h2>
                                <p className="text-center text-muted">
                                    Vision: {smsData?.vision ? `${smsData.vision.length} items` : 'No data'} |
                                    Mission: {smsData?.mission ? `${smsData.mission.length} items` : 'No data'} |
                                    Values: {smsData?.values ? `${smsData.values.length} items` : 'No data'}
                                </p>
                            </div>

                            {/* Vision */}
                            {smsData?.vision && smsData.vision.length > 0 && (
                                <div className="col-lg-4 col-md-6 mb-4">
                                    <div className="vmv-card">
                                        <h3>Our Vision</h3>
                                        <ul className="vmv-list">
                                            {smsData.vision.map((item, index) => (
                                                <li key={index}>{item.text}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            )}

                            {/* Mission */}
                            {smsData?.mission && smsData.mission.length > 0 && (
                                <div className="col-lg-4 col-md-6 mb-4">
                                    <div className="vmv-card">
                                        <h3>Our Mission</h3>
                                        <ul className="vmv-list">
                                            {smsData.mission.map((item, index) => (
                                                <li key={index}>{item.text}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            )}

                            {/* Values */}
                            {smsData?.values && smsData.values.length > 0 && (
                                <div className="col-lg-4 col-md-6 mb-4">
                                    <div className="vmv-card">
                                        <h3>Our Values</h3>
                                        <ul className="vmv-list">
                                            {smsData.values.map((item, index) => (
                                                <li key={index}>{item.text}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* Announcements Section */}
                <div className="announcements-section">
                    <div className="container">
                        <h2 className="text-center mb-5">Latest Updates</h2>

                        {/* Debug: Show section info always */}
                        <div className="col-12 mb-4">
                            <p className="text-center text-muted">
                                Announcements: {smsData?.announcements ? `${smsData.announcements.length} items` : 'No data'} |
                                Events Reports: {smsData?.EventsReports ? `${smsData.EventsReports.length} items` : 'No data'} |
                                Latest News: {smsData?.latestNewsItems ? `${smsData.latestNewsItems.length} items` : 'No data'}
                            </p>
                        </div>

                        <div className="announcements-grid">
                            {/* Announcements */}
                            {smsData?.announcements && smsData.announcements.length > 0 && (
                                <div className="announcement-card">
                                    <h4>📢 Announcements</h4>
                                    <ul className="announcement-list">
                                        {smsData.announcements.map((item, index) => (
                                            <li key={index}>{item.text}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}

                            {/* Events Reports */}
                            {smsData?.EventsReports && smsData.EventsReports.length > 0 && (
                                <div className="announcement-card">
                                    <h4>📋 Events & Reports</h4>
                                    <ul className="announcement-list">
                                        {smsData.EventsReports.map((item, index) => (
                                            <li key={index}>{item.text}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}

                            {/* Latest News */}
                            {smsData?.latestNewsItems && smsData.latestNewsItems.length > 0 && (
                                <div className="announcement-card">
                                    <h4>📰 Latest News</h4>
                                    <ul className="announcement-list">
                                        {smsData.latestNewsItems.map((item, index) => (
                                            <li key={index}>{item.text}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* Associate Entities */}
                {smsData?.associateEntities && smsData.associateEntities.length > 0 && (
                    <div className="associate-entities">
                        <div className="container">
                            <h2 className="text-center mb-4">Our Associates</h2>
                            <div className="entities-grid">
                                {smsData.associateEntities.filter(entity => entity.name).map((entity, index) => (
                                    <div key={index} className="entity-item">
                                        {entity.link ? (
                                            <a href={entity.link} target="_blank" rel="noopener noreferrer">
                                                <strong>{entity.name}</strong>
                                                {entity.description && <p>{entity.description}</p>}
                                            </a>
                                        ) : (
                                            <div style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                height: "100%",
                                                textAlign: "center"
                                            }}>
                                                {entity.logo?.data?.attributes?.url && (
                                                    <img
                                                        src={`${imageBaseURL}${entity.logo.data.attributes.url}`}
                                                        alt={entity.name}
                                                        style={{ width: "80px", height: "80px", objectFit: "contain", marginBottom: "10px" }}
                                                    />
                                                )}
                                                <strong>{entity.name}</strong>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}
                {smsData?.associateEmail && (
                    <div className="text-center mt-4" style={{ 
                        padding: "30px", 
                        background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)", 
                        borderRadius: "15px", 
                        margin: "40px 0",
                        boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
                        border: "1px solid #dee2e6"
                    }}>
                        <div style={{ marginBottom: "15px" }}>
                            <i className="fas fa-envelope" style={{ fontSize: "2rem", marginBottom: "10px", color: "#ff6600", opacity: "0.8" }}></i>
                        </div>
                        <h4 style={{ marginBottom: "15px", fontWeight: "600", color: "#333" }}>
                            We Value Your Feedback
                        </h4>
                        <p style={{ marginBottom: "20px", color: "#666", fontSize: "16px" }}>
                            Post your advice, suggestions, comments, and feedback
                        </p>
                        <a 
                            href={`mailto:${smsData.associateEmail}`} 
                            style={{ 
                                color: "white", 
                                textDecoration: "none",
                                fontSize: "18px",
                                fontWeight: "600",
                                padding: "12px 30px",
                                backgroundColor: "#ff6600",
                                borderRadius: "25px",
                                border: "none",
                                display: "inline-block",
                                transition: "all 0.3s ease",
                                boxShadow: "0 4px 15px rgba(255, 102, 0, 0.3)"
                            }}
                            onMouseOver={(e) => {
                                e.target.style.backgroundColor = "#ff8533";
                                e.target.style.transform = "translateY(-2px)";
                                e.target.style.boxShadow = "0 6px 20px rgba(255, 102, 0, 0.4)";
                            }}
                            onMouseOut={(e) => {
                                e.target.style.backgroundColor = "#ff6600";
                                e.target.style.transform = "translateY(0)";
                                e.target.style.boxShadow = "0 4px 15px rgba(255, 102, 0, 0.3)";
                            }}
                        >
                            📧 {smsData.associateEmail}
                        </a>
                    </div>
                )}
            </div>

            <Accreditation />
            <Footer
                footerClass="rs-footer home9-style main-home"
                footerLogo={footerLogo}
            />
            <ScrollToTop scrollClassName="scrollup orange-color" />
            <SearchModal />
        </React.Fragment>
    );
};

export default SMSHomeMain;
